import { DataTable } from "@/components/composables/DataTable";
import { useGetAllMerchant } from "../misc/mutations";
import { Checkbox } from "@/components/ui/checkbox";

import { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/components/ui/badge";
// import ConfirmModal from "@/components/composables/ConfirmModal";
import Options from "@/components/ui/options";
import useControl from "@/hooks/useControl";
// import { errorLogger } from "@/utils/helper";
// import { useEffect, useState } from "react";
import { useState } from "react";
// import SuccessfulModal from "@/components/composables/SuccessfulModal";
import moment from "moment";
// import EditTaskModal from "./editTaskModal";
// import { useQueryParam } from "@/hooks/useQueryParam";
import Pagination from "../misc/pagination";
import { Merchant } from "../misc/types";
import { Button } from "@/components/ui/button";
import MerchantFormModal from "../misc/addMerchantModal";
import ViewMerchantModal from "../misc/viewMerchantModal";
import EditMerchantModal from "../misc/editMerchantModal";
import DeleteMerchantModal from "../misc/deleteMerchantModal";
import { Filter12Filled } from "@fluentui/react-icons";

const filterFields = [
  { name: "search", label: "Search", type: "text" },
  { name: "mobilePhone", label: "Mobile Phone", type: "text" },
  { name: "email", label: "Email", type: "text" },
  { name: "routeName", label: "Route Name", type: "text" },
  { name: "routeCode", label: "Route Code", type: "text" },
  { name: "merchantName", label: "Merchant Name", type: "text" },
  { name: "merchantType", label: "Merchant Type", type: "text" },
  { name: "bankCode", label: "Bank Code", type: "text" },
  { name: "terminalId", label: "Terminal ID", type: "text" },
  { name: "merchantId", label: "Merchant ID", type: "text" },
  { name: "merchantCode", label: "Merchant Code", type: "text" },
];

const MerchantPage = () => {
  // const { state: isOpen, setTrue: onOpen, setFalse: onClose } = useControl()
  // const { state: isOpenEdit, setTrue: onOpenEdit, setFalse: onCloseEdit } = useControl()
  const {
    state: isOpenView,
    setTrue: onOpenView,
    setFalse: onCloseView,
  } = useControl();
  const {
    state: isOpenViewModal,
    setTrue: onOpenViewModal,
    setFalse: onCloseViewModal,
  } = useControl();
  const {
    state: isOpenEditModal,
    setTrue: onOpenInviteModal,
    setFalse: onCloseEditModal,
  } = useControl();
  const {
    state: isOpenDeleteModal,
    setTrue: onOpenDeleteModal,
    setFalse: onCloseDeleteModal,
  } = useControl();
  // const { state: isSuccessModalOpen, setTrue: openSuccessModal, setFalse: closeSuccessModal } = useControl()
  // const { state: isSuccessModalOpenEdit, setTrue: openSuccessModalEdit, setFalse: closeSuccessModalEdit } = useControl()
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFilters((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSidebarClose = () => setSidebarOpen(false);
  const handleSidebarOpen = () => setSidebarOpen(true);

  const { data, isPending } = useGetAllMerchant({
    size: 10,
    page: currentPage,
    ...filters,
  });

  const [, setTransactionId] = useState("");
  const [merchant, setMerchant] = useState<Merchant>();
  // const pageSize = 10; // Number of transactions per page
  const totalPages = data?.totalPages as number;

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const columns: ColumnDef<Merchant>[] = [
    {
      id: "select",
      header: ({ table }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "merchantId",
      header: "Merchant ID",
      cell: ({ row }) => <div>{row.original.merchantId}</div>,
    },
    {
      accessorKey: "merchantName",
      header: "Merchant Name",
      cell: ({ row }) => <div>{row.original.merchantName}</div>,
    },
    {
      accessorKey: "mobilePhone",
      header: "Mobile Phone",
      cell: ({ row }) => <div>{row.original.mobilePhone}</div>,
    },
    {
      accessorKey: "email",
      header: "Email",
      cell: ({ row }) => <div>{row.original.email || "N/A"}</div>,
    },
    {
      accessorKey: "merchantCode",
      header: "Merchant Code",
      cell: ({ row }) => <div>{row.original.merchantCode}</div>,
    },
    {
      accessorKey: "address",
      header: "Address",
      cell: ({ row }) => <div>{row.original.address || "N/A"}</div>,
    },
    {
      accessorKey: "state",
      header: "State",
      cell: ({ row }) => <div>{row.original.state}</div>,
    },
    {
      accessorKey: "lga",
      header: "LGA",
      cell: ({ row }) => <div>{row.original.lga}</div>,
    },
    {
      accessorKey: "routeName",
      header: "Route Name",
      cell: ({ row }) => <div>{row.original.routeName}</div>,
    },
    {
      accessorKey: "isEnabled",
      header: "Status",
      cell: ({ row }) => (
        <Badge status={row.original.isEnabled ? "Active" : "Inactive"} />
      ),
    },
    {
      accessorKey: "accountLocked",
      header: "Account Status",
      cell: ({ row }) => (
        <div>{row.original.accountLocked ? "Locked" : "Unlocked"}</div>
      ),
    },
    {
      accessorKey: "dateCreated",
      header: "Date Created",
      cell: ({ row }) => (
        <div>{moment(row.original.dateCreated).format("LLLL")}</div>
      ),
    },
    {
      id: "actions",
      cell: ({ row }) => (
        <Options
          setTransactionId={setTransactionId}
          setMerchant={() => setMerchant(row.original)}
          id={row.original.merchantId}
          onOpenView={onOpenViewModal}
          onOpenEdit={onOpenInviteModal}
          onOpenDelete={onOpenDeleteModal}
        />
      ),
    },
  ];

  return (
    <div>
      {/* Filter Button */}
      <div className="flex justify-between items-center mb-4">
        <button
          className="px-4 flex items-center gap-2 py-2 bg-primary-500 text-white rounded hover:bg-primary-600"
          onClick={handleSidebarOpen}
        >
          <Filter12Filled className="text-2xl" />
          Filters
        </button>

        <div className="flex justify-end ">
          <Button
            className="bg-primary-500"
            onClick={onOpenView}>Create Merchant</Button>
        </div>
      </div>
      {/* RHS Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out
          ${sidebarOpen ? "translate-x-0" : "translate-x-full"}`}
        style={{ maxWidth: 360 }}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-semibold">Filter Merchants</h2>
          <button
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            onClick={handleSidebarClose}
            aria-label="Close sidebar"
          >
            &times;
          </button>
        </div>
        <div className="p-4 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 64px)' }}>
          <form className="space-y-3">
            {filterFields.map((field) => (
              <div key={field.name}>
                <label className="block text-sm font-medium mb-1" htmlFor={field.name}>
                  {field.label}
                </label>
                <input
                  id={field.name}
                  name={field.name}
                  type={field.type}
                  value={filters[field.name] || ""}
                  onChange={handleFilterChange}
                  className="border rounded px-2 py-1 w-full"
                />
              </div>
            ))}
          </form>
          <button
            type="button"
            className="mt-6 w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded"
            onClick={() => { setFilters({}); setSidebarOpen(false); }}
          >
            Reset
          </button>
        </div>
      </div>
      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={handleSidebarClose}
        />
      )}

      <DataTable
        isLoading={isPending}
        columns={columns}
        data={(data?.merchants ?? []) as Merchant[]}
      />
      <div className="flex justify-end">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>

      {isOpenView && (
        <MerchantFormModal onClose={onCloseView} isOpen={isOpenView} />
      )}
      {isOpenEditModal && (
        <EditMerchantModal
          onCancel={onCloseEditModal}
          isOpenEdit={isOpenEditModal}
          merchant={merchant as Merchant}
        />
      )}
      {isOpenViewModal && (
        <ViewMerchantModal
          onClose={onCloseViewModal}
          merchant={merchant as Merchant}
        />
      )}
      {isOpenDeleteModal && (
        <DeleteMerchantModal
          merchant={merchant as Merchant}
          onCancel={onCloseDeleteModal}
        />
      )}
    </div>
  );
};

export default MerchantPage;
